<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <!-- PASİF ETME ONAY DİYALOĞU -->
<v-dialog v-model="confirmPasif" max-width="480">
  <v-card class="rounded-xl">
    <v-card-title class="headline">Onay</v-card-title>
    <v-card-text>
      Bu kullanıcı artık kullanılmıyor. Kapatmak ister misiniz?
    </v-card-text>
    <v-divider />
    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn text @click="confirmPasif = false">İptal</v-btn>
      <v-btn color="error" dark @click="pasifEt">Evet, Kapat</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent scrollable max-width="960px">
  <v-card class="rounded-xl">
    <v-toolbar flat dark color="info">
      <v-toolbar-title>{{ dialog_baslik }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="dialog=false"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>

    <v-card-text class="pt-6">
      <v-container fluid>
      
        <v-row dense>
          <v-col cols="12" sm="4">
            <v-text-field
              :disabled="m" outlined dense :label="$t('Code')"
              v-model="KesenKisi.Kodu"
              :error-messages="errors.collect('kodu')"
              v-validate="'required'" data-vv-name="kodu" required
            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              outlined dense :label="$t('Name_label')" v-model="KesenKisi.Adi"
              :error-messages="errors.collect('adi')" v-validate="'required'"
              data-vv-name="adi" required
            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              outlined dense :label="$t('Surname_label')" v-model="KesenKisi.Soyadi"
              :error-messages="errors.collect('soyadi')" v-validate="'required'"
              data-vv-name="soyadi" required
            />
          </v-col>
        </v-row>
        <v-row dense class="mt-2">
  <v-col cols="12" sm="6" class="d-flex align-center">
    <span class="subtitle-2 grey--text text--darken-1 mr-3">
      Kesen Kişi Durumu :
    </span>

    <v-btn
      class="white--text"
      :color="KesenKisi.Pasif ? 'error' : 'success'"
      :disabled="KesenKisi.Pasif === true"
      @click="confirmPasifYap"
      depressed
    >
      {{ KesenKisi.Pasif ? 'PASİF' : 'AKTİF' }}
    </v-btn>
  </v-col>
</v-row>


 

        <v-divider class="my-4"></v-divider>
        <v-subheader class="px-0">Havayolu / GDS Bilgileri</v-subheader>

        
        <v-row dense>
          <v-col cols="12" sm="6" v-for="f in integrationFields" :key="f.key">
            <v-text-field
              outlined dense  :label="f.label"
              v-model="KesenKisi[f.key]"
              hide-details="auto"
              :counter="f.maxLength"
              :maxlength="f.maxLength"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-divider />

    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <template v-if="m">
        <v-btn color="primary" text @click="guncelle()">{{ $t('Update') }}</v-btn>
        <v-btn color="error" text @click="sil()">{{ $t('Delete') }}</v-btn>
      </template>
      <template v-else-if="k">
        <v-btn color="primary" text @click="Kaydet()">{{ $t('save_button') }}</v-btn>
      </template>
      <v-btn text @click="dialog=false">{{ $t('Cancel') }}</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{$t('Ticket-Agent')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
        </v-text-field>



              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="ekle()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('Add-v2', { value: $t('Ticket-Agent')}) }}</span>
                  </span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{ $t('Add-v2', { value: $t('Ticket-Agent')}) }}</span>
              </v-tooltip>
      </v-toolbar>
    </v-layout>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item)" item>
            <td class="text-xs-left">{{ props.item.Kodu }}</td>
            <td class="text-xs-left">{{ props.item.Adi }}</td>
            <td class="text-xs-left">{{ props.item.Soyadi }}</td>
            <td class="text-xs-left">
      <v-chip small :color="props.item.Pasif ? 'error' : 'success'" dark>
        {{ props.item.Pasif ? 'PASİF' : 'AKTİF' }}
      </v-chip>
    </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }}
        </v-alert>
      </v-data-table>
    </v-card>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  export default {
    data() {
      return {
      integrationFields: [
      { label: 'Pegasus',       key: 'Pegasus',maxLength:5 },
      { label: 'THY',           key: 'THY',maxLength:5 },
      { label: 'Amadeus',       key: 'Amadeus' },
      { label: 'AJET',          key: 'Ajet' },
      { label: 'Sabre',         key: 'Sabre' },
      { label: 'Galileo',       key: 'Galileo' },
      { label: 'Booking Agora', key: 'BookingAgora',maxLength:5 },
      { label: 'Biziclick',     key: 'BiziClick',maxLength:5 },
      { label: 'SunExpress',    key: 'SunExpress' },
      { label: 'FLY KHY',       key: 'FlyKhy' },
      { label: 'Atlas',         key: 'Atlas' },
      { label: 'IATI',          key: 'IATI' },
      { label: 'BiletBank',     key: 'BiletBank' },
      { label: 'BiletAll',      key: 'BiletAll' },
    ],
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        items: [],
        search3: '',
        selected: '',
        m: false,
        k: false,
        dialog: false,
        confirmPasif: false,

        KesenKisi: {
          ID: null,
          SirketKodu: null,
          Kodu: null,
          Adi: null,
          Soyadi: null,
          PersonelKodu: null,
          Pegasus: null,
          THY: null,
          Amadeus: null,
          Sabre: null,
          Galileo: null,
          BookingAgora: null,
          BiziClick: null,
          Ajet: null,
          SunExpress: null,
          FlyKhy: null,
          Atlas: null,
          IATI: null,
          BiletBank: null,
          BiletAll: null,
          Pasif: false,
        },
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        analizkod: '',
        analizadi: '',
        tutar: '',
        oran: '',
        progress: false,
        dictionary: {
          custom: {
            kodu: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            adi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            soyadi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        var params = {
          SirketKodu: credentials.SirketKodu,
        }
        this.progress = true
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.items = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })


      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute
              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          } 

        });

      }

    },
    methods: {
 confirmPasifYap() {
    if (this.KesenKisi.Pasif) return
    this.confirmPasif = true
  },
  pasifEt() {
    this.KesenKisi.Pasif = true
    this.confirmPasif = false
    this.text1 = 'Kullanıcı PASİF yapıldı.'
    this.snackbar = true
  },

      Getir(v) {
        this.k = false
        this.m = true
        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Kesen Kişi Güncelle'
        this.KesenKisi = v
        this.KesenKisi = { Pasif: false, ...v }

      },
      sil: sil,
      ekle: ekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog
    },
    computed:{
          headers(){
            return [{
            text: this.$t('Code'),
            value: 'Kodu'
          },
          {
            text: this.$t('Name_label'),
            value: 'Adi'
          },
          {
            text: this.$t('Surname_label'),
            value: 'Soyadi'
          },
          {
            text: this.$t('Durum'),
            value: 'Pasif'
          }
        ]
        },
    }
  }

  function Kaydet() {
    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.KesenKisi.SirketKodu = credentials.SirketKodu

        var params = this.KesenKisi


        this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanSave', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true

          if (response.body.Status) {

            this.dialog = false
            var params = {
              SirketKodu: credentials.SirketKodu,
            }

            this.progress = true
            this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanList', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.progress = false
              this.items = response.body
            }, (response) => {
              if (response.status === 0) {
                this.progress = false
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.progress = false
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true

          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }
    })
  }



  function ekle() {
      this.dialog = true
      this.KesenKisi.Kodu = null,
      this.KesenKisi.Adi = null,
      this.KesenKisi.Soyadi = null,
      this.KesenKisi.Pegasus = null,
      this.KesenKisi.THY = null,
      this.KesenKisi.Amadeus = null,
      this.KesenKisi.Sabre = null,
      this.KesenKisi.Galileo = null,
      this.KesenKisi.BookingAgora = null,
      this.KesenKisi.BiziClick = null,
      this.KesenKisi.Ajet = null,
      this.KesenKisi.SunExpress = null,
      this.KesenKisi.FlyKhy = null,
      this.KesenKisi.Atlas = null,
      this.KesenKisi.IATI = null,
      this.KesenKisi.BiletBank = null,
      this.KesenKisi.BiletAll = null,
      this.KesenKisi.Pasif = false,
      this.dialog_baslik = this.$t('Add-People')
      this.m = false
      this.k = true
      this.$validator.reset()
  }

  function beforeMount() {



  }

  function sil() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.KesenKisi.SirketKodu = credentials.SirketKodu

    var params = this.KesenKisi


    this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanDelete', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

       this.text1 = this.$t(response.body.ResponseMessage)
      this.snackbar = true

      if (response.body.Status) {

        this.dialog = false
        var params = {
          SirketKodu: credentials.SirketKodu,
        }

        this.progress = true
        this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.items = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.progress = false
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })

      } else {
         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true

      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }


  function guncelle(value) {

    this.$validator.validateAll().then((result) => {
      if (result) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.KesenKisi.SirketKodu = credentials.SirketKodu

        var params = this.KesenKisi

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanUpdate', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true

          if (response.body.Status) {

            this.dialog = false
            var params = {
              SirketKodu: credentials.SirketKodu,
            }

            this.progress = true
            this.$http.post(auth.API_URL + 'api/TicketDefinitons/SalesmanList', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.progress = false
              this.items = response.body
            }, (response) => {
              if (response.status === 0) {
                this.progress = false
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.progress = false
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true

          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>